import { Injectable, inject } from '@angular/core';
import { IGeoJSONLineString } from 'modelos/src';
import { HttpClientService } from '../http.service';

export interface QuerySimuladorTracker {
  trackerId: string; // _id de un tracker
  route: IGeoJSONLineString; // ruta en formato GeoJSON LineString
  durationHours?: number; // Por cuánto va a reportar
  speedKmh?: number; // Velocidad (hace que los reportes caigan más rápido o más lento)
  host?: string; // al pedo, por si hay que mandar reportes a otro lado
  port?: number;
}

@Injectable({
  providedIn: 'root',
})
export class ReportesTruchosService {
  private http = inject(HttpClientService);


  public simularTracker(query: QuerySimuladorTracker) {
    const url = `/reportestruchos/tracker/simular`;
    return this.http.post(url, query);
  }
}
